import UserIcon from '@heroicons/react/outline/UserIcon'
import { Link } from 'react-router-dom'

import { Image } from '@tribeplatform/gql-client/types'
import {
  SystemSpaceSlug,
  useAuthToken,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { defaultNavbarControlItems, NavbarControlAction } from '../constants'
import { getNavbarControlPresentation } from '../utils'
import { NavbarControlCreateItem } from './NavbarControlCreateItem'
import { NavbarControlNotification } from './NavbarControlNotification'
import { NavbarControlProfile } from './NavbarControlProfile'

export const NavbarControl = ({ controlItems = defaultNavbarControlItems }) => {
  const {
    data: { member },
  } = useAuthToken()
  const { generatePath, hasViewPermission } = useSpaceUtil()

  const signupViewPermission = hasViewPermission(SystemSpaceSlug.SIGNUP)
  const avatarUrl = (member?.profilePicture as Image)?.urls?.thumb
  const avatarName = member?.name

  const getPresentation = ({ item, props = {} }) =>
    getNavbarControlPresentation({
      item,
      avatarUrl,
      avatarName,
      props,
    })

  return (
    <div className="flex items-center space-x-3 flex-shrink-0">
      {controlItems
        .map(item => {
          switch (item.action) {
            case NavbarControlAction.CREATE_ITEM:
              return (
                <NavbarControlCreateItem
                  key={item.label}
                  item={item}
                  presentation={getPresentation({
                    item,
                    props: {
                      variant: 'primary',
                      rounded: true,
                      className: 'w-10 h-10 px-0 justify-center',
                      as: 'div',
                    },
                  })}
                />
              )
            case NavbarControlAction.SIGNUP:
              if (!signupViewPermission) return null
              return getPresentation({
                item,
                props: {
                  variant: 'primary',
                  className: 'hidden lg:flex',
                  as: Link,
                  to: generatePath(SystemSpaceSlug.SIGNUP),
                },
              })
            case NavbarControlAction.LOGIN:
              if (!hasViewPermission(SystemSpaceSlug.LOGIN)) return null
              return (
                <>
                  <Button
                    as={Link}
                    variant="outline"
                    rounded
                    className="w-10 h-10 px-0 justify-center lg:hidden"
                    to={generatePath(SystemSpaceSlug.LOGIN)}
                    leadingIcon={<UserIcon />}
                  />

                  {getPresentation({
                    item,
                    props: {
                      variant: 'outline',
                      className: 'hidden lg:flex',
                      as: Link,
                      to: generatePath(SystemSpaceSlug.LOGIN),
                    },
                  })}
                </>
              )
            case NavbarControlAction.SHOW_NOTIFICATION:
              if (!hasViewPermission(SystemSpaceSlug.NOTIFICATIONS)) return null
              return (
                <NavbarControlNotification
                  key={item.label}
                  item={item}
                  presentation={getPresentation({
                    item,
                    props: {
                      variant: 'outline',
                      rounded: true,
                      className: 'w-10 h-10 px-0 justify-center',
                      as: 'div',
                    },
                  })}
                />
              )
            case NavbarControlAction.SHOW_PROFILE:
              if (!hasViewPermission(SystemSpaceSlug.MEMBER)) return null
              return (
                <NavbarControlProfile
                  key={item.label}
                  item={item}
                  presentation={getPresentation({ item })}
                />
              )
            default:
              return null
          }
        })
        .filter(item => item)}
    </div>
  )
}
